<div>
    <h2 mat-dialog-title>{{iteration?.year}} - Members</h2>
    
    <mat-dialog-content>
        <div class="container-fluid">
            <div class="d-flex gap-2 mb-3 justify-content-end">
                <button mat-raised-button (click)="onAddMembers()" [disabled]="isLoading">
                    Add Members <mat-icon>add</mat-icon>
                </button>
                <button mat-raised-button class="secondary" (click)="onSendAllPaymentLinks()" [disabled]="isLoading || iterationMembers.length === 0 || allMembersPaid">
                    Send Payment Links <mat-icon>email</mat-icon>
                </button>
            </div>

            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            
            <table mat-table [dataSource]="iterationMembers" *ngIf="!isLoading">
                <ng-container matColumnDef="memberName">
                    <th mat-header-cell *matHeaderCellDef> Member Name </th>
                    <td mat-cell *matCellDef="let member"> {{getMemberName(member)}} </td>
                </ng-container>

                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef> Email </th>
                    <td mat-cell *matCellDef="let member"> {{member.email}} </td>
                </ng-container>

                <ng-container matColumnDef="paid">
                    <th mat-header-cell *matHeaderCellDef> Paid </th>
                    <td mat-cell *matCellDef="let member">
                        <mat-slide-toggle
                            [checked]="member.paid"
                            (change)="onTogglePayment(member)"
                            [disabled]="isLoading">
                            <ng-container *ngIf="member.paid">Yes</ng-container>
                            <ng-container *ngIf="!member.paid">No</ng-container>
                        </mat-slide-toggle>
                    </td>
                </ng-container>

                <ng-container matColumnDef="paymentType">
                    <th mat-header-cell *matHeaderCellDef> Payment Type </th>
                    <td mat-cell *matCellDef="let member"> 
                        <mat-chip-set>
                            <mat-chip highlighted="true"
                                [class]="member.paid ? 'primary' : 'warning'"
                                chipListSelectable="false">{{getPaymentType(member.paymentType)}}</mat-chip>
                        </mat-chip-set>
                 </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let member">
                        <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #actionsMenu>
                            <button mat-menu-item (click)="setPaymentType(member)" *ngIf="!member.paid">
                                <mat-icon>payment</mat-icon>
                                <span>Set Payment Type</span>
                            </button>
                            <button mat-menu-item (click)="onSendPaymentLink(member)" *ngIf="!member.paid">
                                <mat-icon>send</mat-icon>
                                <span>Send Payment Link</span>
                            </button>
                            <button class="warning" mat-menu-item (click)="onRemoveMember(member)">
                                <mat-icon class="warning">remove_circle</mat-icon>
                                <span class="warning">Remove from Iteration</span>
                            </button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div *ngIf="iterationMembers.length === 0 && !isLoading" class="text-center py-5">
                <p [ngClass]="{'text-muted': !isDarkMode, 'text-muted-dark-mode': isDarkMode}">No members yet. Click "Add Members" to add members to this iteration.</p>
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <div class="text-center w-100">
            <button mat-raised-button (click)="close()">
                Close
            </button>
        </div>
    </mat-dialog-actions>
</div>
<ng-template #myTemplate let-data let-dialogRef="dialogRef">
     <div class="container-fluid">
         <h2 mat-dialog-title>Choose Payment Type</h2>
         <div mat-dialog-content>
         <p>Choose the payment type for {{ data.firstName }} {{ data.lastName }}</p>
             <mat-form-field class="w-100">
                 <mat-select [(ngModel)]="data.paymentType">
                 <mat-option *ngFor="let type of paymentTypes" [value]="type.value">
                     {{ type.label }}
                 </mat-option>
                 </mat-select>
             </mat-form-field>
         </div>
         <div mat-dialog-actions>
             <button mat-button class="warning" (click)="dialogRef.close()">Close</button>
             <button mat-button class="primary" (click)="dialogRef.close(data)">Save</button>
         </div>
      </div>
  </ng-template>